import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import './InfoPage.css';

const ContactPage = () => {
  const navigate = useNavigate();
  return (
    <div className="info-page">
      <div className="info-header-wrap"><Header /></div>
      <div className="info-container">
        <button className="back-btn" onClick={() => navigate('/')}>← Back</button>
        <h1>About Us</h1>
        <p>MyHelpz is India’s trusted on-demand human assistance platform, designed to make everyday life easier. We connect you with skilled, background-verified assistants who can help with household tasks, shopping, travel, healthcare visits, events, and more. Wherever life takes you, MyHelpz ensures dependable human assistance is always within reach.</p>
        
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
